// Keeper side of "one paired phone per match" (see app/models/signing_device.rb).
//
// The per-person QR code still works exactly as it always did — this only adds
// a push to the paired phone on top of it, so the modal that opens always
// contains the QR as well.
//
// Used by pre_match.js, scoresheet.js and match_report.js, which used to carry
// three copies of the QR-modal code.

global.signing = {
  data: { paired: false, connected: false, urls: {}, notes: {} },

  // opts = { deviceUrl, pushUrl, matchFmsId, state }
  init: function(opts) {
    signing.data.urls = { device: opts.deviceUrl, push: opts.pushUrl };
    signing.setState(opts.state || {});

    if(opts.matchFmsId) {
      ws.subscribe("SigningChannel", { matchId: opts.matchFmsId }, signing.onEvent);
    }
    $(document).on('click', '#signing-pair-btn', signing.pair);
    $(document).on('click', '#signing-unpair-btn', signing.unpair);
  },

  // --- the per-person signature: push if we can, always offer the QR --------

  // person = { name, uuid }, urlTemplate = the page's signature url with XXidXX
  // in it. Passed in rather than configured, so the QR still works on a page
  // that never called init (a read-only report, say).
  //
  // The QR modal opens either way. Whether a phone got the request is decided
  // by the server, not by what this page believes: our `paired` flag can be
  // stale (a missed broadcast, a phone re-paired elsewhere), and claiming
  // "sent to the phone" when nothing was sent is the one thing that would
  // leave a referee waiting.
  request: function(person, urlTemplate) {
    if(!person || !person.uuid) return;
    var url = urlTemplate.replace("XXidXX", person.uuid);

    alerts.show({
      title: person.name,
      body: "<p class='signing-push-note' data-uuid='" + person.uuid + "'>Skeniraj QR kodo s telefonom in podpiši!</p>"
            + "<a href='" + url + "' target='_blank'><div class='signature-qr-code' id='" + person.uuid + "'></div></a>",
      type: 'info',
      onShowCallback: function() {
        new QRCode(document.getElementById(person.uuid), { text: url, width: 400, height: 400 });
        signing.applyNote(person.uuid);   // in case the push already answered
      }
    });

    signing.push(person.uuid);
  },

  push: function(uuid) {
    if(!signing.data.urls.push) return;

    $.ajax(signing.data.urls.push, {
      method: 'POST',
      data: { signature_uuid: uuid },
      success: function(data) {
        signing.setState(data);
        signing.data.notes[uuid] = "<i class='fas fa-mobile-alt mr-2'></i>Poslano na povezan telefon — podpiše naj tam."
                                   + "<br><small>Če telefona ni pri roki, lahko skenira tudi spodnjo QR kodo.</small>";
        signing.applyNote(uuid);
      },
      error: function(xhr) {
        // 409 not_paired: nothing is paired, or the phone was replaced or the
        // pairing expired. The QR code in the modal is untouched, so signing is
        // never blocked by any of that.
        if(xhr.status == 409 || xhr.status == 404) {
          signing.setState({ paired: false, connected: false });
        }
      }
    });
  },

  // The answer and the modal race each other, and either can win: the note is
  // remembered per person and written whenever both exist.
  applyNote: function(uuid) {
    var html = signing.data.notes[uuid];
    if(!html) return;

    $(".signing-push-note[data-uuid='" + uuid + "']").addClass('alert alert-info').html(html);
  },

  // --- pairing --------------------------------------------------------------

  pair: function() {
    $.ajax(signing.data.urls.device, {
      method: 'POST',
      success: function(data) {
        signing.setState(data);
        alerts.show({
          title: 'Poveži telefon s tekmo',
          body: "<p>Skeniraj to QR kodo <b>enkrat</b>. Nato bo telefon do konca tekme ostal povezan —"
                + " podpise mu pošlješ s klikom na ikono podpisa pri posamezni osebi.</p>"
                + "<div class='signature-qr-code' id='signing-pair-qr'></div>"
                + "<p class='mt-3 mb-0' id='signing-pair-status'>" + signing.statusHtml() + "</p>"
                + "<p class='mt-2 mb-0'><button type='button' class='btn btn-sm btn-outline-danger' id='signing-unpair-btn'>Odklopi telefon</button></p>",
          type: 'info',
          onShowCallback: function() {
            new QRCode(document.getElementById('signing-pair-qr'), { text: data.pairUrl, width: 400, height: 400 });
          }
        });
      }
    });
  },

  unpair: function() {
    $.ajax(signing.data.urls.device, {
      method: 'DELETE',
      success: function(data) {
        signing.setState(data);
        $('.modal.show').modal('hide');
      }
    });
  },

  // --- state ---------------------------------------------------------------

  onEvent: function(data) {
    if(data && data.action == 'state') {
      signing.setState(data);
    }
  },

  setState: function(data) {
    if(typeof data.paired !== 'undefined') signing.data.paired = !!data.paired;
    if(typeof data.connected !== 'undefined') signing.data.connected = !!data.connected;
    signing.refreshButton();
    $('#signing-pair-status').html(signing.statusHtml());
  },

  statusHtml: function() {
    if(signing.data.connected) {
      return "<span class='tag'><span class='chip__dot chip__dot--on'></span> Telefon povezan</span>";
    } else if(signing.data.paired) {
      return "<span class='tag tag--open'>Telefon povezan, a se ne odziva</span>";
    }
    return "<span class='tag'>Ni povezanega telefona</span>";
  },

  // Confirmed states are neutral text plus a glyph, never Bootstrap's success green —
  // on this design a green chip is indistinguishable from a Q3 ink mark.
  refreshButton: function() {
    var $btn = $('#signing-pair-btn');
    if($btn.length === 0) return;

    var label = signing.data.paired ? "Telefon povezan" : "Poveži telefon";
    $btn.toggleClass('is-paired', signing.data.paired);
    var dot = signing.data.paired ? "<span class='chip__dot chip__dot--on mr-1'></span>" : "<i class='fas fa-mobile-alt mr-1'></i>";
    $btn.html(dot + label);
  }
};
